// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__f6LKF","content":"styles_content__2DaJr","selectAll":"styles_selectAll__sK6xg"};